export const CloseIcon = ({ h, w, ...props }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      className={props?.css}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8847 2.88322L21.1172 1.11572L12.0009 10.232L2.88469 1.11572L1.11719 2.88322L10.2334 11.9995L1.11719 21.1157L2.88469 22.8832L12.0009 13.7682L21.1172 22.8832L22.8847 21.1157L13.7684 11.9995L22.8847 2.88322Z"
        fill="#373838"
        stroke="#373838"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const ArrowIcon = () => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4655 7.86154L3.08397 0.466828C2.37847 -0.155609 1.23463 -0.155609 0.529126 0.466828C-0.176375 1.08927 -0.176375 2.09844 0.529126 2.72087L7.6462 9L0.529126 15.2791C-0.176375 15.9016 -0.176375 16.9107 0.529126 17.5332C1.23463 18.1556 2.37847 18.1556 3.08397 17.5332L11.4655 10.1385C12.1782 9.50971 12.1782 8.49029 11.4655 7.86154Z"
        fill="#0C0C0D"
      />
    </svg>
  );
};

export const AudienceIcon = ({ h, w }) => {
  return (
    <svg
      width={w || "36"}
      height={h || "36"}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.5653 7.96387C26.7979 7.96387 27.8064 8.97787 27.8064 10.2139C27.8064 11.4499 26.7979 12.4639 25.5653 12.4639C24.3327 12.4639 23.3242 11.4499 23.3242 10.2139C23.3242 8.97787 24.3327 7.96387 25.5653 7.96387Z"
        fill="#383838"
      />
      <path
        d="M28.5544 22.9639H22.5781V16.9639C22.5781 15.3079 23.9168 13.9639 25.5663 13.9639C27.2157 13.9639 28.5544 15.3079 28.5544 16.9639V22.9639Z"
        fill="#383838"
      />
      <path
        d="M18.0966 10.9639C19.3292 10.9639 20.3377 11.9779 20.3377 13.2139C20.3377 14.4499 19.3292 15.4639 18.0966 15.4639C16.864 15.4639 15.8555 14.4499 15.8555 13.2139C15.8555 11.9779 16.864 10.9639 18.0966 10.9639Z"
        fill="#383838"
      />
      <path
        d="M21.0818 25.9639H15.1055V19.9639C15.1055 18.3079 16.4442 16.9639 18.0936 16.9639C19.7431 16.9639 21.0818 18.3079 21.0818 19.9639V25.9639Z"
        fill="#383838"
      />
      <path
        d="M10.6239 7.96387C11.8565 7.96387 12.865 8.97787 12.865 10.2139C12.865 11.4499 11.8565 12.4639 10.6239 12.4639C9.39131 12.4639 8.38281 11.4499 8.38281 10.2139C8.38281 8.97787 9.39131 7.96387 10.6239 7.96387Z"
        fill="#383838"
      />
      <path
        d="M13.613 22.9639H7.63672V16.9639C7.63672 15.3079 8.97541 13.9639 10.6249 13.9639C12.2743 13.9639 13.613 15.3079 13.613 16.9639V22.9639Z"
        fill="#383838"
      />
      <rect x="6" y="22.7998" width="24" height="3.6" fill="#383838" />
    </svg>
  );
};

export const ChatIcon = ({ h, w }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4 2.4V16.8H7.2V19.2L10.4004 16.8H21.6V2.4H2.4ZM4.8 24V19.2H2.4C1.0764 19.2 0 18.1236 0 16.8V2.4C0 1.0764 1.0764 0 2.4 0H21.6C22.9236 0 24 1.0764 24 2.4V16.8C24 18.1236 22.9236 19.2 21.6 19.2H11.1996L4.8 24Z"
        fill="#0C0C0D"
      />
    </svg>
  );
};

export const FilterGroupIcon = ({ h, w }) => {
  return (
    <svg
      width={w || "19"}
      height={h || "18"}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0625 2.625C16.5791 2.625 17 3.045 17 3.5625C17 4.08 16.5791 4.5 16.0625 4.5C15.5459 4.5 15.125 4.08 15.125 3.5625C15.125 3.045 15.5459 2.625 16.0625 2.625ZM16.0625 6.375C17.6131 6.375 18.875 5.11312 18.875 3.5625C18.875 2.01188 17.6131 0.75 16.0625 0.75C14.8419 0.75 13.8116 1.53562 13.4234 2.625H0.125V4.5H13.4234C13.8116 5.58938 14.8419 6.375 16.0625 6.375Z"
        fill="#373838"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6875 10.125C6.17094 10.125 5.75 9.705 5.75 9.1875C5.75 8.67 6.17094 8.25 6.6875 8.25C7.20406 8.25 7.625 8.67 7.625 9.1875C7.625 9.705 7.20406 10.125 6.6875 10.125ZM6.6875 6.375C5.46688 6.375 4.43656 7.16063 4.04844 8.25H0.125V10.125H4.04844C4.43656 11.2144 5.46688 12 6.6875 12C7.90812 12 8.93844 11.2144 9.32656 10.125H18.875V8.25H9.32656C8.93844 7.16063 7.90812 6.375 6.6875 6.375Z"
        fill="#373838"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0625 15.75C15.5459 15.75 15.125 15.33 15.125 14.8125C15.125 14.295 15.5459 13.875 16.0625 13.875C16.5791 13.875 17 14.295 17 14.8125C17 15.33 16.5791 15.75 16.0625 15.75ZM16.0625 12C14.8419 12 13.8116 12.7856 13.4234 13.875H0.125V15.75H13.4234C13.8116 16.8394 14.8419 17.625 16.0625 17.625C17.6131 17.625 18.875 16.3631 18.875 14.8125C18.875 13.2619 17.6131 12 16.0625 12Z"
        fill="#373838"
      />
    </svg>
  );
};

export const BackButtonIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.75 34C32.0972 34 34 32.0972 34 29.75V4.25C34 1.90279 32.0972 0 29.75 0H4.25C1.90279 0 0 1.90279 0 4.25V29.75C0 32.0972 1.90279 34 4.25 34H29.75ZM12.1274 15.9375H24.4375C25.0243 15.9375 25.5 16.4132 25.5 17C25.5 17.5868 25.0243 18.0625 24.4375 18.0625H12.1274L16.6898 22.6227C17.1052 23.0382 17.1052 23.7118 16.6898 24.1273C16.2743 24.5427 15.6007 24.5427 15.1852 24.1273L8.81025 17.7523C8.61041 17.5529 8.4981 17.2823 8.4981 17C8.4981 16.7177 8.61041 16.4471 8.81025 16.2477L15.1852 9.87275C15.6007 9.45729 16.2743 9.45729 16.6898 9.87275C17.1052 10.2882 17.1052 10.9618 16.6898 11.3773L12.1274 15.9375Z"
        fill="#00A89A"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill="#00A89A" />
      <g>
        <svg
          x="8"
          y="8"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0625 2.625C16.5791 2.625 17 3.045 17 3.5625C17 4.08 16.5791 4.5 16.0625 4.5C15.5459 4.5 15.125 4.08 15.125 3.5625C15.125 3.045 15.5459 2.625 16.0625 2.625ZM16.0625 6.375C17.6131 6.375 18.875 5.11312 18.875 3.5625C18.875 2.01188 17.6131 0.75 16.0625 0.75C14.8419 0.75 13.8116 1.53562 13.4234 2.625H0.125V4.5H13.4234C13.8116 5.58938 14.8419 6.375 16.0625 6.375Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.6875 10.125C6.17094 10.125 5.75 9.705 5.75 9.1875C5.75 8.67 6.17094 8.25 6.6875 8.25C7.20406 8.25 7.625 8.67 7.625 9.1875C7.625 9.705 7.20406 10.125 6.6875 10.125ZM6.6875 6.375C5.46688 6.375 4.43656 7.16062 4.04844 8.25H0.125V10.125H4.04844C4.43656 11.2144 5.46688 12 6.6875 12C7.90812 12 8.93844 11.2144 9.32656 10.125H18.875V8.25H9.32656C8.93844 7.16062 7.90812 6.375 6.6875 6.375Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0625 15.75C15.5459 15.75 15.125 15.33 15.125 14.8125C15.125 14.295 15.5459 13.875 16.0625 13.875C16.5791 13.875 17 14.295 17 14.8125C17 15.33 16.5791 15.75 16.0625 15.75ZM16.0625 12C14.8419 12 13.8116 12.7856 13.4234 13.875H0.125V15.75H13.4234C13.8116 16.8394 14.8419 17.625 16.0625 17.625C17.6131 17.625 18.875 16.3631 18.875 14.8125C18.875 13.2619 17.6131 12 16.0625 12Z"
            fill="white"
          />
        </svg>
      </g>
    </svg>
  );
};

export const CircleRightChevron = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="29.533" height="31" rx="14.7665" fill="#00A89A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.236 14.8828C19.6974 15.2734 19.6974 15.9065 19.236 16.2971L13.8104 20.8899C13.3537 21.2765 12.6132 21.2765 12.1565 20.8899C11.6998 20.5034 11.6998 19.8765 12.1565 19.4899L16.7637 15.5899L12.1565 11.6899C11.6998 11.3034 11.6998 10.6765 12.1565 10.2899C12.6132 9.90335 13.3537 9.90335 13.8104 10.2899L19.236 14.8828Z"
        fill="white"
      />
      <mask
        id="mask0_4_47075"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="10"
        width="9"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.236 14.8828C19.6974 15.2734 19.6974 15.9065 19.236 16.2971L13.8104 20.8899C13.3537 21.2765 12.6132 21.2765 12.1565 20.8899C11.6998 20.5034 11.6998 19.8765 12.1565 19.4899L16.7637 15.5899L12.1565 11.6899C11.6998 11.3034 11.6998 10.6765 12.1565 10.2899C12.6132 9.90335 13.3537 9.90335 13.8104 10.2899L19.236 14.8828Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4_47075)"></g>
    </svg>
  );
};

export const MoveSortIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 9.99994H13V5.41394L14.293 6.70694L15.707 5.29294L12 1.58594L8.293 5.29294L9.707 6.70694L11 5.41394V9.99994H5V11.9999H19V9.99994Z"
        fill="#757575"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 16V14H5V16H11V20.586L9.707 19.293L8.293 20.707L12 24.414L15.707 20.707L14.293 19.293L13 20.586V16H19Z"
        fill="#757575"
      />
    </svg>
  );
};

export const SessionIcon = () => {
  return (
    <svg
      width="27"
      height="22"
      viewBox="0 0 27 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.62686 19.8L4.09316 15.4H22.3081L23.7744 19.8H2.62686ZM22.0001 13.2H4.40006V2.2H22.0001V13.2ZM25.9964 19.5085L24.2001 14.1207V1.1C24.2001 0.4928 23.7073 0 23.1001 0H3.30006C2.69286 0 2.20006 0.4928 2.20006 1.1V14.1207L0.404864 19.5085C0.200264 20.1223 0.283864 20.7515 0.633664 21.2366C0.983464 21.7217 1.55436 22 2.20006 22H24.2001C24.8469 22 25.4178 21.7217 25.7676 21.2366C26.1163 20.7515 26.1999 20.1223 25.9964 19.5085Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70039 12.1004V4.40039H9.90039V12.1004H7.70039Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1008 12.0998V8.7998H14.3008V12.0998H12.1008Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5012 12.0996V6.59961H18.7012V12.0996H16.5012Z"
        fill="black"
      />
    </svg>
  );
};

export const EncryptionLock = ({ ...props }) => {
  return (
    <svg
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8348 5.15586C13.8359 5.79868 14.3567 6.31951 14.9995 6.3206C15.6415 6.3206 16.1642 5.79786 16.1642 5.15586V1.16474C16.1642 0.522742 15.6415 0 14.9995 0C14.3575 0 13.8348 0.522742 13.8348 1.16474V5.15586ZM7.91367 9.0645C7.64431 9.065 7.38358 8.96952 7.17826 8.79518L4.04181 6.21725C3.80361 6.02136 3.65332 5.7386 3.62422 5.43157C3.59512 5.12455 3.68961 4.81859 3.88677 4.58144C4.08195 4.34251 4.36435 4.19127 4.6714 4.16123C4.97845 4.1312 5.2848 4.22485 5.52258 4.42144L8.65903 6.99937C9.50277 7.69305 9.00586 9.0645 7.91367 9.05953V9.0645ZM5.88919 31.4302C6.128 31.669 6.45196 31.803 6.78968 31.8028H23.2073C23.5451 31.803 23.869 31.669 24.1078 31.4302C24.3466 31.1914 24.4807 30.8674 24.4804 30.5297V18.3814C24.4804 17.6778 23.911 17.1034 23.2073 17.1034H21.665V15.1416C21.665 11.4665 18.6736 8.47517 14.9985 8.47517C11.3234 8.47517 8.33206 11.4665 8.33206 15.1416V17.1034H6.78968C6.08606 17.1034 5.51661 17.6778 5.51661 18.3814V30.5297C5.51635 30.8674 5.65039 31.1914 5.88919 31.4302ZM14.9995 21.9223C16.7387 21.9223 17.3449 24.231 15.8333 25.0846L15.8323 26.7304C15.8323 27.8385 14.1657 27.8385 14.1657 26.7304V25.0846C12.6601 24.226 13.2653 21.9273 14.9995 21.9223ZM12.1582 17.1024H17.8468V15.1406C17.8468 13.5724 16.5687 12.2993 14.9995 12.2993C13.4303 12.2993 12.1582 13.5724 12.1582 15.1406V17.1024ZM1.16474 15.2967H5.12406C5.76606 15.2967 6.2888 14.7739 6.2888 14.1319C6.2888 13.4899 5.76606 12.9672 5.12406 12.9672H1.16474C0.517773 12.9672 0 13.4899 0 14.1319C0 14.7739 0.517773 15.2967 1.16474 15.2967ZM22.0853 9.0645C20.9882 9.0645 20.4962 7.69305 21.34 6.99937L24.4764 4.42144C25.6769 3.43757 27.1527 5.23437 25.9572 6.22321L22.8208 8.80114C22.6139 8.97219 22.3538 9.06569 22.0853 9.06549V9.0645ZM24.8392 15.2967H28.8353C29.4822 15.2967 30 14.7739 30 14.1319C30 13.4899 29.4822 12.9672 28.8353 12.9672H24.8392C24.1922 12.9672 23.6744 13.4899 23.6744 14.1319C23.6744 14.7739 24.1922 15.2967 24.8392 15.2967Z"
        fill={props?.color || "#000000"}
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="30"
      height="18"
      viewBox="0 0 30 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 0C12.4244 0.0114225 9.75465 0.638309 7.2274 1.83852C5.35095 2.76636 3.52225 4.07542 1.93485 5.69119C1.1552 6.51598 0.160775 7.71027 0 8.98451C0.019 10.0883 1.20325 11.4507 1.93485 12.2779C3.42342 13.8302 5.2045 15.1027 7.2274 16.1315C9.58418 17.275 12.1928 17.9334 15 17.97C17.5781 17.9584 20.2472 17.3243 22.7717 16.1315C24.6481 15.2036 26.4777 13.8936 28.0651 12.2779C28.8448 11.4531 29.8392 10.2588 30 8.98451C29.981 7.88073 28.7967 6.51828 28.0651 5.69114C26.5766 4.13883 24.7945 2.86729 22.7717 1.83847C20.4161 0.695821 17.8011 0.0419657 15 0ZM19.4961 8.98311C19.4961 11.3659 17.4795 13.2975 14.9918 13.2975C12.5042 13.2975 10.4876 11.3659 10.4876 8.98311C10.4876 6.60034 12.5042 4.66877 14.9918 4.66877C17.4795 4.66874 19.4961 6.60036 19.4961 8.98311ZM22.065 8.98549C22.065 5.25489 18.9011 2.23071 14.9981 2.23071C11.0951 2.23071 7.93122 5.25489 7.93122 8.98549C7.93122 12.716 11.0951 15.7402 14.9981 15.7402C18.9011 15.7402 22.065 12.7161 22.065 8.98549Z"
        fill="#23364A"
      />
    </svg>
  );
};

export const CheckedIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.61539C0 4.30769 4.30769 0 9.61539 0C14.9231 0 19.2308 4.30769 19.2308 9.61539C19.2308 14.9231 14.9231 19.2308 9.61539 19.2308C4.30769 19.2308 0 14.9231 0 9.61539ZM2.88462 9.61539L7.69231 14.4231L16.3462 5.76923L14.9904 4.40385L7.69231 11.7019L4.24038 8.25961L2.88462 9.61539Z"
        fill="#00A89A"
      />
    </svg>
  );
};

export const NetworkIcon = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5714 17.4545C15.6263 17.4545 14.8571 16.7204 14.8571 15.8182C14.8571 14.916 15.6263 14.1818 16.5714 14.1818C17.5166 14.1818 18.2857 14.916 18.2857 15.8182C18.2857 16.7204 17.5166 17.4545 16.5714 17.4545ZM8.57143 6.54545C9.51657 6.54545 10.2857 7.27964 10.2857 8.18182C10.2857 9.084 9.51657 9.81818 8.57143 9.81818C7.62629 9.81818 6.85714 9.084 6.85714 8.18182C6.85714 7.27964 7.62629 6.54545 8.57143 6.54545ZM20 2.18182C20.9451 2.18182 21.7143 2.916 21.7143 3.81818C21.7143 4.72036 20.9451 5.45455 20 5.45455C19.0549 5.45455 18.2857 4.72036 18.2857 3.81818C18.2857 2.916 19.0549 2.18182 20 2.18182ZM4 20.7273C3.05486 20.7273 2.28571 19.9931 2.28571 19.0909C2.28571 18.1887 3.05486 17.4545 4 17.4545C4.94514 17.4545 5.71429 18.1887 5.71429 19.0909C5.71429 19.9931 4.94514 20.7273 4 20.7273ZM24 3.81818C24 1.71273 22.2057 0 20 0C17.7943 0 16 1.71273 16 3.81818C16 5.18291 16.7611 6.37418 17.8926 7.04945L16.4754 12.0098C15.8251 12.0251 15.2217 12.1953 14.6834 12.4735L12.0754 9.984C12.3817 9.44509 12.5714 8.83745 12.5714 8.18182C12.5714 6.07636 10.7771 4.36364 8.57143 4.36364C6.36571 4.36364 4.57143 6.07636 4.57143 8.18182C4.57143 9.38945 5.17371 10.4564 6.09371 11.1556L4.35429 15.3065C4.23657 15.2967 4.12114 15.2727 4 15.2727C1.79429 15.2727 0 16.9855 0 19.0909C0 21.1964 1.79429 22.9091 4 22.9091C6.20571 22.9091 8 21.1964 8 19.0909C8 17.8833 7.39771 16.8175 6.47657 16.1171L8.216 11.9662C8.33486 11.976 8.45029 12 8.57143 12C9.25829 12 9.89486 11.8189 10.4594 11.5265L13.0674 14.016C12.7611 14.5549 12.5714 15.1625 12.5714 15.8182C12.5714 17.9236 14.3657 19.6364 16.5714 19.6364C18.7771 19.6364 20.5714 17.9236 20.5714 15.8182C20.5714 14.4535 19.8103 13.2622 18.6789 12.5869L20.096 7.62655C22.256 7.57636 24 5.892 24 3.81818Z"
      fill="currentColor"
    />
  </svg>
);

export const TutorialIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.50002 0H18.5C19.3271 0 20 0.695309 20 1.54968V11.4503C20 12.3046 19.3271 12.9999 18.5 12.9999H10.8578C10.6525 12.2103 10.2144 11.5215 9.6175 10.9999H12V8.99996H16V10.9999H18V1.99999H7.00002V3.55623C6.40939 3.21186 5.7319 2.99998 5.00003 2.99998V1.54968C5.00003 0.695309 5.67283 0 6.50002 0ZM5.00003 9.99995C6.65689 9.99995 8.00001 8.65683 8.00001 6.99996C8.00001 5.3431 6.65689 3.99998 5.00003 3.99998C3.34316 3.99998 2.00004 5.3431 2.00004 6.99996C2.00004 8.65683 3.34316 9.99995 5.00003 9.99995ZM6.50002 10.9999C6.42533 10.9999 6.35064 11.0109 6.27939 11.034C5.8744 11.1656 5.44846 11.2499 5.00003 11.2499C4.55159 11.2499 4.12565 11.1656 3.72034 11.034C3.64909 11.0109 3.57472 10.9999 3.50003 10.9999C1.56067 10.9999 -0.010262 12.5774 5.04835e-05 14.5193C0.00442546 15.3399 0.67911 15.9999 1.50004 15.9999H8.50001C9.32094 15.9999 9.99563 15.3399 10 14.5193C10.0103 12.5774 8.43938 10.9999 6.50002 10.9999Z"
      fill="black"
    />
  </svg>
);

export const DocumentationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.81818 1.81818H7.27273V0H1.81818C0.815455 0 0 0.816364 0 1.81818V7.27273H1.81818V1.81818Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1811 0H12.7266V1.81818H18.1811V7.27273H19.9993V1.81818C19.9993 0.816364 19.1838 0 18.1811 0Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.81818 12.7275H0V18.1821C0 19.1848 0.815455 20.0003 1.81818 20.0003H7.27273V18.1821H1.81818V12.7275Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1811 18.1821H12.7266V20.0003H18.1811C19.1838 20.0003 19.9993 19.1848 19.9993 18.1821V12.7275H18.1811V18.1821Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 11.2155C8.42457 11.2155 7.14286 9.87411 7.14286 8.22527C7.14286 7.27137 7.58057 6.39223 8.28571 5.83723V7.62721C8.28571 8.6164 9.05486 9.42138 10 9.42138C10.9451 9.42138 11.7143 8.6164 11.7143 7.62721V5.83723C12.4194 6.39223 12.8571 7.27137 12.8571 8.22527C12.8571 9.87411 11.5754 11.2155 10 11.2155ZM14 8.22527C14 6.45741 12.9286 4.87256 11.3331 4.28228L10.5714 4V7.62721C10.5714 7.95734 10.3149 8.22527 10 8.22527C9.68514 8.22527 9.42857 7.95734 9.42857 7.62721V4L8.66686 4.28228C7.07143 4.87256 6 6.45741 6 8.22527C6 9.89085 6.93657 11.328 8.28571 12.002V16H9.42857V12.4117H10.5714V16H11.7143V12.002C13.0634 11.328 14 9.89085 14 8.22527Z"
      fill="black"
    />
    <path
      d="M8.28571 5.83723H8.41071V5.57977L8.2084 5.739L8.28571 5.83723ZM11.7143 5.83723L11.7916 5.739L11.5893 5.57977V5.83723H11.7143ZM11.3331 4.28228L11.2897 4.39949L11.2898 4.39952L11.3331 4.28228ZM10.5714 4L10.6149 3.88279L10.4464 3.82037V4H10.5714ZM9.42857 4H9.55357V3.82037L9.38513 3.88279L9.42857 4ZM8.66686 4.28228L8.71023 4.39952L8.71029 4.39949L8.66686 4.28228ZM8.28571 12.002H8.41071V11.9247L8.34158 11.8902L8.28571 12.002ZM8.28571 16H8.16071V16.125H8.28571V16ZM9.42857 16V16.125H9.55357V16H9.42857ZM9.42857 12.4117V12.2867H9.30357V12.4117H9.42857ZM10.5714 12.4117H10.6964V12.2867H10.5714V12.4117ZM10.5714 16H10.4464V16.125H10.5714V16ZM11.7143 16V16.125H11.8393V16H11.7143ZM11.7143 12.002L11.6584 11.8902L11.5893 11.9247V12.002H11.7143ZM10 11.0905C8.49891 11.0905 7.26786 9.8105 7.26786 8.22527H7.01786C7.01786 9.93772 8.35023 11.3405 10 11.3405V11.0905ZM7.26786 8.22527C7.26786 7.30943 7.6882 6.46659 8.36302 5.93545L8.2084 5.739C7.47294 6.31786 7.01786 7.23331 7.01786 8.22527H7.26786ZM8.16071 5.83723V7.62721H8.41071V5.83723H8.16071ZM8.16071 7.62721C8.16071 8.68001 8.98052 9.54638 10 9.54638V9.29638C9.1292 9.29638 8.41071 8.55279 8.41071 7.62721H8.16071ZM10 9.54638C11.0195 9.54638 11.8393 8.68001 11.8393 7.62721H11.5893C11.5893 8.55279 10.8708 9.29638 10 9.29638V9.54638ZM11.8393 7.62721V5.83723H11.5893V7.62721H11.8393ZM11.637 5.93545C12.3118 6.46659 12.7321 7.30943 12.7321 8.22527H12.9821C12.9821 7.23331 12.5271 6.31786 11.7916 5.739L11.637 5.93545ZM12.7321 8.22527C12.7321 9.8105 11.5011 11.0905 10 11.0905V11.3405C11.6498 11.3405 12.9821 9.93772 12.9821 8.22527H12.7321ZM14.125 8.22527C14.125 6.40789 13.0236 4.77443 11.3765 4.16505L11.2898 4.39952C12.8336 4.9707 13.875 6.50693 13.875 8.22527H14.125ZM11.3766 4.16507L10.6149 3.88279L10.528 4.11721L11.2897 4.39949L11.3766 4.16507ZM10.4464 4V7.62721H10.6964V4H10.4464ZM10.4464 7.62721C10.4464 7.89365 10.2406 8.10027 10 8.10027V8.35027C10.3891 8.35027 10.6964 8.02103 10.6964 7.62721H10.4464ZM10 8.10027C9.7594 8.10027 9.55357 7.89365 9.55357 7.62721H9.30357C9.30357 8.02103 9.61088 8.35027 10 8.35027V8.10027ZM9.55357 7.62721V4H9.30357V7.62721H9.55357ZM9.38513 3.88279L8.62342 4.16507L8.71029 4.39949L9.47201 4.11721L9.38513 3.88279ZM8.62348 4.16505C6.97643 4.77443 5.875 6.40789 5.875 8.22527H6.125C6.125 6.50693 7.16642 4.9707 8.71023 4.39952L8.62348 4.16505ZM5.875 8.22527C5.875 9.93818 6.83831 11.4186 8.22985 12.1138L8.34158 11.8902C7.03483 11.2373 6.125 9.84353 6.125 8.22527H5.875ZM8.16071 12.002V16H8.41071V12.002H8.16071ZM8.28571 16.125H9.42857V15.875H8.28571V16.125ZM9.55357 16V12.4117H9.30357V16H9.55357ZM9.42857 12.5367H10.5714V12.2867H9.42857V12.5367ZM10.4464 12.4117V16H10.6964V12.4117H10.4464ZM10.5714 16.125H11.7143V15.875H10.5714V16.125ZM11.8393 16V12.002H11.5893V16H11.8393ZM11.7702 12.1138C13.1617 11.4186 14.125 9.93818 14.125 8.22527H13.875C13.875 9.84353 12.9652 11.2373 11.6584 11.8902L11.7702 12.1138Z"
      fill="black"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0625 2.625C16.5791 2.625 17 3.045 17 3.5625C17 4.08 16.5791 4.5 16.0625 4.5C15.5459 4.5 15.125 4.08 15.125 3.5625C15.125 3.045 15.5459 2.625 16.0625 2.625ZM16.0625 6.375C17.6131 6.375 18.875 5.11312 18.875 3.5625C18.875 2.01188 17.6131 0.75 16.0625 0.75C14.8419 0.75 13.8116 1.53562 13.4234 2.625H0.125V4.5H13.4234C13.8116 5.58938 14.8419 6.375 16.0625 6.375Z"
      fill="#373838"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.6875 10.125C6.17094 10.125 5.75 9.705 5.75 9.1875C5.75 8.67 6.17094 8.25 6.6875 8.25C7.20406 8.25 7.625 8.67 7.625 9.1875C7.625 9.705 7.20406 10.125 6.6875 10.125ZM6.6875 6.375C5.46688 6.375 4.43656 7.16063 4.04844 8.25H0.125V10.125H4.04844C4.43656 11.2144 5.46688 12 6.6875 12C7.90812 12 8.93844 11.2144 9.32656 10.125H18.875V8.25H9.32656C8.93844 7.16063 7.90812 6.375 6.6875 6.375Z"
      fill="#373838"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0625 15.75C15.5459 15.75 15.125 15.33 15.125 14.8125C15.125 14.295 15.5459 13.875 16.0625 13.875C16.5791 13.875 17 14.295 17 14.8125C17 15.33 16.5791 15.75 16.0625 15.75ZM16.0625 12C14.8419 12 13.8116 12.7856 13.4234 13.875H0.125V15.75H13.4234C13.8116 16.8394 14.8419 17.625 16.0625 17.625C17.6131 17.625 18.875 16.3631 18.875 14.8125C18.875 13.2619 17.6131 12 16.0625 12Z"
      fill="#373838"
    />
  </svg>
);

export const ShopIcon = () => (
  <svg
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.75 13.0343L11.9106 23.8736L10.2951 19.8315C10.1804 19.5469 9.95312 19.3196 9.6685 19.2049L5.62638 17.5894L16.4657 6.75H22.75V13.0343ZM11.5 27C11.7959 27 12.0828 26.8841 12.2954 26.6704L24.6704 14.2954C24.8819 14.085 25 13.7981 25 13.5V5.625C25 5.004 24.496 4.5 23.875 4.5H16C15.7019 4.5 15.415 4.61925 15.2046 4.82963L2.82962 17.2046C2.56187 17.4724 2.44712 17.856 2.52362 18.2261C2.599 18.5962 2.8555 18.9045 3.2065 19.0451L8.38375 21.1162L10.4549 26.2935C10.5955 26.6445 10.9038 26.901 11.2739 26.9775C11.3492 26.9921 11.4246 27 11.5 27Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.125 10.125C17.125 11.3659 18.133 12.375 19.375 12.375C20.6181 12.375 21.625 11.3659 21.625 10.125C21.625 8.88188 20.6181 7.875 19.375 7.875C18.133 7.875 17.125 8.88188 17.125 10.125Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.17038 14.2954L14.2158 2.25H21.625V0H13.75C13.4519 0 13.165 0.118125 12.9546 0.329625L0.579624 12.7046L2.17038 14.2954Z"
      fill="currentColor"
    />
  </svg>
);

export const CampaignIcon = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2857 13.3929L6.85714 10.5358V5.46378L18.2857 2.60663V13.3929ZM2.28571 5.71406H4.57143V10.2855H2.28571V5.71406ZM20.1314 0.242063C19.8537 0.0237778 19.4914 -0.0527937 19.1509 0.0340635L5.57371 3.42835H2.28571C1.02514 3.42835 0 4.45235 0 5.71406V10.2855C0 11.5449 1.02514 12.5712 2.28571 12.5712H4.57143V14.8569C4.57143 15.1049 4.65143 15.3449 4.8 15.5426L8.22857 20.1141L10.0571 18.7426L6.85714 14.4752V12.8923L19.1509 15.9655C19.2423 15.9883 19.336 15.9998 19.4286 15.9998C19.6811 15.9998 19.9291 15.9163 20.1314 15.7575C20.4091 15.5403 20.5714 15.2089 20.5714 14.8569V1.14263C20.5714 0.790635 20.4091 0.458063 20.1314 0.242063Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7148 4.78223V11.2177C23.0428 10.7445 24.0006 9.48737 24.0006 7.99937C24.0006 6.51251 23.0428 5.25537 21.7148 4.78223Z"
      fill="currentColor"
    />
  </svg>
);

export const CircleFilled = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17Z"
      fill="#d8d8d8"
    />
  </svg>
);

export const FinanceIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.6C6.7068 21.6 2.4 17.2932 2.4 12C2.4 6.7068 6.7068 2.4 12 2.4C17.2932 2.4 21.6 6.7068 21.6 12C21.6 17.2932 17.2932 21.6 12 21.6ZM12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3832 18.6168 0 12 0Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1197 11.04C15.1197 9.58445 13.9365 8.40005 12.4809 8.40005H11.5197C11.3877 8.40005 11.2809 8.29205 11.2809 8.16005C11.2809 8.02685 11.3877 7.91885 11.5197 7.91885H14.8809V5.51885H12.9597V4.80005H11.0409V5.56805C9.81446 5.79485 8.88086 6.86765 8.88086 8.16005C8.88086 9.61565 10.0641 10.8 11.5197 10.8H12.4809C12.6129 10.8 12.7197 10.908 12.7197 11.04C12.7197 11.172 12.6129 11.28 12.4809 11.28H9.11966V13.68H11.0409V14.4H12.9597V13.632C14.1861 13.4052 15.1197 12.3324 15.1197 11.04Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.6002 21.6H7.2002V19.2H9.6002V21.6Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1998 21.6H10.7998V15.6H13.1998V21.6Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8004 21.6H14.4004V16.8H16.8004V21.6Z"
      fill="currentColor"
    />
  </svg>
);

export const CommunicationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.4 2.4V16.8H7.2V19.2L10.4004 16.8H21.6V2.4H2.4ZM4.8 24V19.2H2.4C1.0764 19.2 0 18.1236 0 16.8V2.4C0 1.0764 1.0764 0 2.4 0H21.6C22.9236 0 24 1.0764 24 2.4V16.8C24 18.1236 22.9236 19.2 21.6 19.2H11.1996L4.8 24Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 9.59998C7.5 10.428 6.828 11.1 6 11.1C5.172 11.1 4.5 10.428 4.5 9.59998C4.5 8.77198 5.172 8.09998 6 8.09998C6.828 8.09998 7.5 8.77198 7.5 9.59998Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 9.59998C13.5 10.428 12.828 11.1 12 11.1C11.172 11.1 10.5 10.428 10.5 9.59998C10.5 8.77198 11.172 8.09998 12 8.09998C12.828 8.09998 13.5 8.77198 13.5 9.59998Z"
      fill="currentColor"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 9.59998C19.5 10.428 18.828 11.1 18 11.1C17.172 11.1 16.5 10.428 16.5 9.59998C16.5 8.77198 17.172 8.09998 18 8.09998C18.828 8.09998 19.5 8.77198 19.5 9.59998Z"
      fill="currentColor"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M18.6496 13.1655C19.5548 13.1655 20.2953 13.9072 20.2953 14.8112C20.2953 15.7153 19.5548 16.457 18.6496 16.457C17.7445 16.457 17.0039 15.7153 17.0039 14.8112C17.0039 13.9072 17.7445 13.1655 18.6496 13.1655Z" fill="currentColor"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M20.8456 23.0399H16.457V19.7485C16.457 18.5372 17.4401 17.5542 18.6513 17.5542C19.8626 17.5542 20.8456 18.5372 20.8456 19.7485V23.0399Z" fill="currentColor"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.0676 13.1655C12.9727 13.1655 13.7133 13.9072 13.7133 14.8112C13.7133 15.7153 12.9727 16.457 12.0676 16.457C11.1624 16.457 10.4219 15.7153 10.4219 14.8112C10.4219 13.9072 11.1624 13.1655 12.0676 13.1655Z" fill="currentColor"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M14.2597 23.0399H9.87109V19.7485C9.87109 18.5372 10.8541 17.5542 12.0654 17.5542C13.2766 17.5542 14.2597 18.5372 14.2597 19.7485V23.0399Z" fill="currentColor"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M5.48556 13.1655C6.3907 13.1655 7.13127 13.9072 7.13127 14.8112C7.13127 15.7153 6.3907 16.457 5.48556 16.457C4.58042 16.457 3.83984 15.7153 3.83984 14.8112C3.83984 13.9072 4.58042 13.1655 5.48556 13.1655Z" fill="currentColor"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M7.67763 23.0399H3.28906V19.7485C3.28906 18.5372 4.2721 17.5542 5.48335 17.5542C6.69459 17.5542 7.67763 18.5372 7.67763 19.7485V23.0399Z" fill="currentColor"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M22.353 11.8285L12.0673 3.59994L1.78049 11.8285L0.410156 10.1148L12.0673 0.789062L23.7233 10.1148L22.353 11.8285Z" fill="currentColor"/>
  </svg>
)